export { default } from "./src/customer-stat";
